//API 설정
export default {
    API_HOST: process.env.VUE_APP_API_URL
}
